export default __webpack_public_path__ + "static/media/cbc28c865d0342aec468ab63c8b98ac2.png";